 <template>
  <div>
    <v-card class="mx-auto" width="95%">
      <v-card-title>
        <v-toolbar-title>Listar de Publicações</v-toolbar-title>
      </v-card-title>
      <v-card-text>
      <ComboGrupo :multiple="true"/>
        <v-data-table
            :headers="columns"
            :items="publicacoes"
            :items-per-page="5"
            class="elevation-0" >
            <template v-slot:item="row">
                <tr>
                    <td>{{ row.item.grupo ? row.item.grupo.descricao : "" }}</td>
                    <td>{{ row.item.titulo }}</td>
                    <td>{{ row.item.text }}</td>
                    <td>{{ dateFormatted(row.item.data) }}</td>
                    <td>{{ row.item.publicado }}</td>
                </tr>
            </template>
        </v-data-table>
      <br />
      <v-btn depressed small dark @click="dlgNovaPublicacao=true">Nova Publicacao</v-btn>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dlgNovaPublicacao" transition="dialog-bottom-transition">
      <Publicacao v-model="dlgNovaPublicacao" :isNew="true"/>
    </v-dialog>
  </div>
</template>
 
 <script>
import moment from 'moment'
import ComboGrupo from "../../widget/ComboGrupos";
import Publicacao from "./Publicacao";
import PublicacaoService from "@/services/publicacaoService"
export default {
  data() {
    return {
      dlgNovaPublicacao: false,
      columns: [
            { text: "Grupo", align: "left" },
            { text: "Titulo", align: "center" },
            { text: "Texto", align: "center" },
            { text: "Data", align: "center" },
            { text: "Publicado", align: "center" },
            { text: "" },
        ],
      publicacoes: []
    };
  },
  methods: {
      async carregarPublicacoes() {
          try{
            var retorno = await PublicacaoService.listarPublicacao()
            this.publicacoes = retorno.data.data.listarPublicacao
            console.log(this.publicacoes)

          } catch(error) {
              alert(error)
          }
      },
      dateFormatted (date) {
          moment.locale('pt-BR');
          return date ? moment(date).format('dddd, DD/MM/YYYY') : ''
       },
  },
  created() {
    this.carregarPublicacoes()
  },
  components: {
    ComboGrupo,
    Publicacao
  }
};
</script>
 
 <style>
.v-list-item__content {
  flex: initial !important;
}
.font-weight-light {
  margin-left: 10px;
}
</style>